import isEqual from "lodash/isEqual";
import { useRef, useEffect } from "react";

export const useDeepEffect = (
  effect: React.EffectCallback,
  deps: React.DependencyList
) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isFirstEffect = isFirst.current;
    const isSame = prevDeps.current.every((obj, index) =>
      isEqual(obj, deps[index])
    );

    isFirst.current = false;
    prevDeps.current = deps;

    if (isFirstEffect || !isSame) {
      return effect();
    }
  }, deps);
};
